// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__dPRcw","total":"Cart_total__6uOBp","actions":"Cart_actions__d7L03","button--alt":"Cart_button--alt__EpiXD","button":"Cart_button__N4SVd"};